module.exports = __webpack_public_path__ + "img/1476343622.3297e2fe.jpg";